import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function BancosCreate() {
  const { user } = useContext(AuthContext);
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;


  const [banco, setBanco] = useState("");
  const [cuenta, setCuenta] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const saveBanco = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_BANCOS,
        {
          banco,
          cuenta,
          cargos: 0,
          abonos: 0,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Cuenta Banco",
            detalle: `${banco} / ${cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <Form onSubmit={saveBanco}>
        <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
          <Label for="exampleEmail" className="mr-sm-2">
            Banco
          </Label>
          <Input
            type="text"
            placeholder="Banco"
            value={banco}
            required
            onChange={(e) => {
              setBanco(e.target.value);
            }}
          />
          <Label for="exampleEmail" className="mr-sm-2">
            Cuenta
          </Label>
          <Input
            type="text"
            placeholder="Cuenta"
            value={cuenta}
            required
            onChange={(e) => {
              setCuenta(e.target.value);
            }}
          />
        </FormGroup>
        <div className="submit-bar">
          {validaBoton ? (
            <Button type="submit" className="btn btn-success">
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          ) : (
            <Button type="submit" className="btn btn-success" disabled>
              <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
            </Button>
          )}
          <div>
            <SweetAlert
              show={text}
              title="Creado con Exito"
              onConfirm={() => {
                setText(false);
              }}
            />
          </div>
        </div>
      </Form>
    </>
  );
}

export default BancosCreate;
